import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'environments/environment'

@Pipe({
    name: 'dataTestId',
    standalone: true,
  })
  export class DataTestIdPipe implements PipeTransform {
  
    constructor() {}
  
    transform(id: string): string | null {
      return (environment.production) ? null : id;
    }                 
  
  }
  